import { Dispatch } from 'react';
import * as ActionTypes from 'src/constants/ActionTypes';
import { IStoreState, IStateSpuCPM } from 'src/entity/StateEntity';
import { MallService } from 'src/services/MallService';
import { ISpuMedicineDetail } from 'src/entity/SpuEntity';
import { EnumMedicineCategory } from 'src/constants/enum';

export function reloadSpuCPM(): IStateSpuCPM {
  return {
    reload: true,
    isFetching: false,
    type: ActionTypes.SPU_CPM_STATUS_RELOAD,
    cpmList: [],
  };
}

export function requestSpuCPM(): IStateSpuCPM {
  return {
    reload: false,
    isFetching: true,
    type: ActionTypes.SPU_CPM_STATUS_REQUEST,
    cpmList: [],
  };
}

function receiveSpuCPM(cpmList: ISpuMedicineDetail[], isSuccess: boolean): IStateSpuCPM {
  return {
    reload: !isSuccess,
    isFetching: false,
    type: isSuccess ? ActionTypes.SPU_CPM_STATUS_SUCCESS : ActionTypes.SPU_CPM_STATUS_FAILURE,
    cpmList,
  };
}

export function fetchSpuCPM(): any {
  return async (dispatch: Dispatch<IStateSpuCPM>) => {
    dispatch(reloadSpuCPM());
    return MallService.getSpuMedicineList({ categoryCode: EnumMedicineCategory.中成药 })
      .then(res => dispatch(receiveSpuCPM(res.results, true)))
      .catch(error => dispatch(receiveSpuCPM([], false)));
  };
}

export function shouldFetchSpuCPM(spuCpmState: IStateSpuCPM): boolean {
  return (spuCpmState.reload || spuCpmState.cpmList.length === 0) && !spuCpmState.isFetching;
}

export function fetchSpuCPMIfNeeded(): any {
  return (dispatch: Dispatch<IStateSpuCPM>, getState: any) => {
    const { spuCpmState } = getState() as IStoreState;
    if (shouldFetchSpuCPM(spuCpmState)) {
      return dispatch(fetchSpuCPM());
    }
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/spuCPMCreator.ts